
import { FSXABaseRichTextElement } from 'fsxa-pattern-library'
import { Component } from 'nuxt-property-decorator'

@Component({
  name: 'Linebreak',
})
export default class Linebreak extends FSXABaseRichTextElement {}
